var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading || _vm.results[0].buyIns > 0)?_c('stat-card',{attrs:{"label":"Argent misé","loading":_vm.loading,"stat":!_vm.loading
      ? _vm.results.map(function (r) { return r.buyIns; }).reduce(function (a, b) { return a + b; }) * 10 + ' €'
      : '',"color-class":"bg-green-500"}},[_c('cash-icon',{staticClass:"w-6 h-6 text-white"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }